  import React, { useState, useEffect, useRef } from "react";
import { useObserver } from "Hooks/useObserver";
import styled, { css } from "styled-components";

export const LazyComponent = ({
  source,
  children,
  timeout = 0,
  Placeholder,
  overlay,
  height,
  className
}) => {
  const domRef = useRef();
  const [isVisible, setVisible] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  const [placeholderSource, setPlaceholderSource] = useState("");
  const observe = useObserver(domRef);
  useEffect(() => {
    if (source != undefined) {
      let query = source.indexOf("?") > -1 ? "&height=10" : "?height=10";
      setPlaceholderSource(source + query);
    }
  }, []);
  useEffect(() => {
    if (!isVisible && observe) {
      setVisible(true);
    }
  }, [observe]);

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => setFadeIn(isVisible), timeout);
    }
  }, [isVisible]);
  
  return (
    <Lazy onload={fadeIn} ref={domRef}>
      {source != "" &&
        (Placeholder != undefined ? (
          <Placeholder bgImage={placeholderSource}  aria-hidden={true}/>
        ) : (
          <PlaceholderBase overlay={overlay} bgImage={placeholderSource} aria-hidden={true} />
        ))}
      <Wrapper className={className || ''} height={height}>{isVisible && children}</Wrapper>
    </Lazy>
  );
};
export const Lazy = styled.div.attrs(
  ({ bgImage, onload, isCropped, coordinates, display, height }) => ({
    show: onload !== undefined ? onload : false,
    display: display ? display : undefined,
    height: height ? height : undefined,
  })
)`
  transition: 0.2s ease;
  ${({ show }) =>
    show &&
    css`
      opacity: 1;
    `}
  ${({ height }) =>
    height &&
    css`
      height: ${({ height }) => height};
    `}
  ${({ display }) =>
    display &&
    css`
      display: ${({ display }) => display};
    `}
`;
const Wrapper = styled.div`
    position: relative;
    min-height: ${({ height }) => (height ? height : "100%")};
    width: 100%;
`;

export const PlaceholderBase = styled.div.attrs(
  ({ bgImage, onload, overlay }) => ({
    show: onload !== undefined ? onload : false,
    bgImage: bgImage ? bgImage : "",
    background: overlay ? `${overlay}${bgImage ? `, url(${bgImage})` : ''}` : undefined,
  })
)`
  position: absolute;
  transition: 0.2s ease;
  ${({ background }) =>
    background &&
    css`
      background: ${({ background }) => background};
      background-size: cover;
      background-repeat: no-repeat;
  `}
  flex-basis: 100%;
  min-height: 16rem;
  width: 100%;
  display: flex;
  align-items: flex-end;
`;
